import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';
import { SortOption } from '~shared/modules/application-event/models/sort-option.model';

export class GATrackingProductSortedEvent implements GATrackingEvent {

  constructor(private sortOption: SortOption) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ProductsListSorting;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.ProductsSorted,
      label: this.getSortOptionLabel()
    };
  }

  private getSortOptionLabel(): string {
    const sortOptionName = this.sortOption.key;
    return `${sortOptionName.charAt(0).toUpperCase()}${sortOptionName.slice(1)}: `
       + `${this.sortOption.value.toUpperCase()}`;
  }
}
